/*
 * Register an event listener on element that's only run once before
 * being unregistered.
 */
const addOneshotEventListener = (element, event, listener) => {
  const unhook = () => {
    element.removeEventListener(event, hook)
  }

  const hook = (event) => {
    unhook()
    listener(event)
  }

  element.addEventListener(event, hook)

  return unhook
}
/**
 * Read unpoly from `window.up` and forward it to the provided function, or
 * raise an error if not found.
 */
export const withUnpoly = (fn = null, { required = true } = {}) => {
  const unpoly = window.up

  const ERROR = "`window.up` is not defined. Make sure UnpolyJS is loaded."

  if (unpoly) {
    if (fn) {
      fn(unpoly)
    }
  } else if (required) {
    throw new Error(ERROR)
  } else {
    console.error(ERROR)
  }

  return unpoly
}

const newChangeEvent = (targetElement) => {
  // Create a proper change event
  const changeEvent = new Event("change", {
    bubbles: true,
    cancelable: true,
    composed: true,
  })

  // Add custom properties that might be expected
  Object.defineProperty(changeEvent, "target", {
    value: targetElement,
    enumerable: true,
  })
  Object.defineProperty(changeEvent, "currentTarget", {
    value: targetElement,
    enumerable: true,
  })

  return changeEvent
}

export default {
  addOneshotEventListener,
  newChangeEvent,
  withUnpoly,
}
